import "./SkeletonCards.css"
import Skeleton from "src/shared/components/layout/skeleton/Skeleton"
import cx from 'classnames'

function SkeletonCards({className}:{className?: string}): JSX.Element {
    return (
        <div className={cx("gastos-cards-skeleton-container", className)}>
            {[1, 2, 3, 4, 5].map((index) => (
                <div key={index} className="home-screen-skeleton-card">
                    <div className="gastos-card-skeleton-left">
                        <Skeleton elements={1} className="gastos-card-skeleton-first" />
                        <Skeleton elements={1} className="gastos-card-skeleton-second" />
                    </div>
                    <Skeleton elements={1} className="gastos-card-skeleton-right" />
                </div>
            ))}
        </div>
    )
}

export default SkeletonCards
